export default __webpack_public_path__ + "static/media/loading-result.423800ed.svg";